"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = assertStringOrNumber;
function assertStringOrNumber(value) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
  if (typeof value !== 'string' && typeof value !== 'number') {
    throw new TypeError("".concat(label, " needs to be a string or number"));
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/web-validations/dist/utils/assertStringOrNumber.js
// module id = 1882
// module chunks = 0